<template>
    <div class="place">
        <Head-view :showStyle="2"></Head-view>
        <div class="main">
            <div class="breadcrumb">点位管理</div>
            <div class="nav">
                <div class="searchLeft">
                    <div class="fontName">点位名称</div>
                    <div class="searchInp">
                        <el-input
                            v-model="searchVal"
                            prefix-icon="el-icon-search"
                            placeholder="请输入"
                        ></el-input>
                    </div>
                    <div class="searchBtn" @click="searchBtn()">搜索</div>
                </div>
                <div class="institutionAddBtn" @click="addInstitution()">
                    新增巡检点位
                </div>
                <div
                    class="importImgBtn institutionAddBtn"
                    @click="importImg()"
                >
                    批量导出二维码
                </div>
            </div>

            <div class="showTba">
                <div class="bodyTable">
                    <el-table
                        :data="tableData"
                        style="width: 100%; max-height: 489px"
                        height="489px"
                        v-loading="loading"
                        :header-cell-style="{ textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center' }"
                    >
                        <el-table-column
                            prop="name"
                            label="点位名称"
                            width="350"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="province"
                            label="点位图片"
                            width="450"
                        >
                            <template slot-scope="scope">
                                <div class="picture">
                                    <img v-if="scope.row.picture" :src="scope.row.picture" alt="" />
                                    <img v-if="!scope.row.picture" src="../../assets/placeDefaultImg.png" alt="" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="经纬度" width="400">
                            <template slot-scope="scope">
                                <div v-html="scope.row.tudeStr"></div>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="300">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleEide(scope.$index, scope.row)"
                                    type="text"
                                    size="small"
                                    class="colorBulr"
                                    >编辑</el-button
                                >
                                <el-button
                                    type="text"
                                    size="small"
                                    class="colorRed"
                                    @click="removeInst(scope.$index, scope.row)"
                                    >删除</el-button
                                >
                                <el-button
                                    class="colorBulr"
                                    type="text"
                                    size="small"
                                    @click="lookImg(scope.row)"
                                    >二维码</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageObj.currentPage"
                        :page-sizes="pageObj.pageSizeArr"
                        :page-size="pageObj.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageObj.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog title="二维码" :visible.sync="dialogVisible" width="30%">
            <div class="towImg" ref="towImgRef">
                <img :src="towImg" alt="" />
            </div>
            <div class="towImgFont">{{ towImgFont }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="loadTowImg()"
                    >下 载</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
export default {
    name: "place",
    data() {
        return {
            searchVal: "",
            loading: false,
            tableData: [],

            dialogVisible: false,
            towImg: "",
            towImgFont: "",

            insId: "",

            pageObj: {
                currentPage: 1,
                pageSizeArr: [10, 40, 100, 400],
                pageSize: 10,
                total: 0,
            },
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"));
        this.placeInfo();
    },

    methods: {
        placeInfo(searchFlag = false) {
            this.loading = true;
            if (this.searchVal != '' && searchFlag) {
                this.pageObj.currentPage = 1
            }
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                keyword: this.searchVal,
                page: this.pageObj.currentPage,
                limit: this.pageObj.pageSize,
            };
            this.request
                .post(this.baseUrl + "place/getPlaceList", data)
                .then((res) => {
                    if (res.code == 0 && res.data.totalCount >= 0) {
                        let dataArr = res.data.list;
                        dataArr.forEach((item, key) => {
                            let tudeStr = "";
                            tudeStr = `<p>经度 ${item.longitude}</p><p>纬度 ${item.latitude}</p>`;
                            dataArr[key]["tudeStr"] = tudeStr;
                        });
                        this.tableData = dataArr;
                        this.pageObj.total = res.data.totalCount;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$message({
                        type: "warning",
                        message: "获取点位列表失败",
                    });
                });
        },

        addInstitution() {
            this.$router.push("/place/placeAdd");
        },
        handleSizeChange(val) {
            this.pageObj.pageSize = val;
            this.placeInfo();
        },
        handleCurrentChange(val) {
            this.pageObj.currentPage = val;
            this.placeInfo();
        },
        handleEide(index, row) {
            this.$router.push({
                path: "/place/placeAdd",
                query: {
                    id: row.placeId,
                },
            });
        },

        searchBtn() {
            this.placeInfo(true);
        },

        importImg() {
            let data = {
                token: this.getCookie(),
                insId: this.insId,
            };
            this.request
                .post(this.baseUrl + "place/exportPlaceQRCode", data)
                .then((res) => {
                    if (res.code == 0 && res.data.url) {
                        let a = document.createElement('a')
                        let event = new MouseEvent('click')
                        a.href = res.data.url
                        // a.href = "http://121.37.9.19:8001/file/222点位二维码.zip"
                        a.download = localStorage.getItem("staffNumber") + '_点位二维码'
                        a.dispatchEvent(event)
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.$message({
                        type: "error",
                        message: '出错了，导出失败',
                    });
                });
        },
        lookImg(row) {
            this.towImg = "";
            this.dialogVisible = true;
            this.towImg =
                this.getGenerator +
                `data={"insId":${this.insId},"placeId":${row.placeId}}` +
                "&size=224x224";
            this.towImgFont = row.name;
            // let image = new Image()
            // image.src = this.towImg
            // image.style.width = '100%'
            // image.onload = () => {
            //     this.$refs.towImgRef.append(image)
            // }
        },

        loadTowImg(name = "") {
            this.$message({
                type: "success",
                message: "右键点击图片另存为",
            });
            //var image = new Image();
            //let _this = this;
            //image.setAttribute("crossOrigin", "anonymous");
            //image.onload = function () {
            //    var canvas = document.createElement("canvas");
            //    canvas.width = image.width;
            //    canvas.height = image.height;
            //    var context = canvas.getContext("2d");
            //    context.drawImage(image, 0, 0, image.width, image.height);
            //    var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
            //    var a = document.createElement("a"); // 生成一个a元素
            //    var event = new MouseEvent("click"); // 创建一个单击事件
            //    a.download = _this.towImgFont; // 设置图片名称
            //    a.href = url; // 将生成的URL设置为a.href属性
            //    a.dispatchEvent(event); // 触发a的单击事件
            //};
            image.src = this.towImg;
        },

        removeInst(index, row) {
            //删除点位
            this.$confirm("确定要删除该点位吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = {
                        token: this.getCookie(),
                        placeId: row.placeId,
                    };
                    this.request
                        .post(this.baseUrl + "place/deletePlace", data)
                        .then((res) => {
                            if (res.code == 0 && res.data.result) {
                                this.tableData.splice(index, 1);
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            this.$message({
                                type: "error",
                                message: "删除失败",
                            });
                        });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="less" scoped>
.place {
    height: 100vh;

    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            margin-left: 7px;
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
        }
        .nav {
            margin-top: 24px;
            margin-left: 7px;
            height: 68px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            .searchLeft {
                float: left;
                margin: 12px 0 0 20px;
                display: flex;
                flex-direction: row;
                height: 40px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                .fontName {
                    width: 72px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    line-height: 40px;
                }
                .searchInp {
                    width: 211px;
                }
                .departName {
                    width: 64px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    text-align: center;
                    line-height: 40px;
                }
                .searchBtn {
                    margin-left: 20px;
                    width: 68px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: rgba(4, 134, 254, 1);
                    border-radius: 4px;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                }
            }

            .institutionAddBtn {
                margin: 14px 17px 0 0;
                float: right;
                width: 115px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                background: rgba(4, 134, 254, 1);
                border-radius: 4px;
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }

            .importImgBtn {
                width: 115px;
                height: 40px;
                opacity: 1;
                background-color: rgba(103, 194, 58, 1);
            }
        }
        .showTba {
            margin-top: 24px;
            padding: 16px 17px 0 31px;
            height: 618px;
            background: #fff;
            .bodyTable {
                width: 100%;
                height: 500px;
                overflow: hidden;
                overflow-y: auto;

                .picture {
                    margin: 0 auto;
                    width: 78px;
                    height: 78px;
                    img {
                        width: 100%;
                    }
                }
            }
            .pageination {
                margin-top: 69px;
                text-align: right;
            }
        }

        .colorRed {
            color: rgba(255, 87, 51, 1);
        }

        .colorBulr {
            color: rgba(25, 137, 250, 1);
        }
    }

    .towImg {
        margin: 0 auto;
        padding: 20px;
        width: 264px;
        height: 264px;
        border: 1px solid rgba(229, 229, 229, 1);
        border-radius: 4px;

        img {
            width: 100%;
        }
    }

    .towImgFont {
        margin-top: 20px;
        text-align: center;
        color: rgba(84, 85, 86, 1);
    }
}
</style>